export function stripAdministrationItemFromCartItems({cartItems}) {
    return cartItems.slice().filter(cartItem => cartItem.item !== 'Administratiekosten')
}